module.exports = __webpack_public_path__ + "static/media/northerRealmBorder.c9f6e263.png";